import React from "react";

function HistoryArea({ videoHandler }) {
  return (
    <section className="history-area pt-120 pb-120">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="history-img-wrap">
              <ul className="list-wrap">
                <li>
                  <img
                    src={require(`../../assets/img/images/history_img01.jpg`)}
                    alt=""
                  />
                </li>
                <li>
                  <img
                    src={require(`../../assets/img/images/history_img02.jpg`)}
                    alt=""
                  />
                </li>
                <li>
                  <img
                    src={require(`../../assets/img/images/history_img03.jpg`)}
                    alt=""
                  />
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="history-content">
              <div className="section-title mb-20">
                <span className="sub-title">Informace</span>
                <h2 className="title">Více o nás</h2>
              </div>

              <div className="history-list">
                <ul className="list-wrap">
                  <li>
                    <i className="fas fa-check"></i>Na trhu od roku 2002
                  </li>
                  <li>
                    <i className="fas fa-check"></i>Mezinárodní partneři
                  </li>
                  <li>
                    <i className="fas fa-check"></i>Zajištění materiálu pro
                    strojírenský, chemický a petrochemický, letecký průmysl a
                    energetiku
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HistoryArea;
